import CustomTable from "components/common/CustomTable";
import SynthTooltip from "components/common/SynthTooltip";
import VendorAvatar from "components/common/VendorAvatar";
import { formatMoney, getCurrencyFromCurrencyCode } from "helpers";
import React from "react";

type CreatePOProps = {
    resultMessage: {
        message: string;
        createdPOs: Record<string, any>;
        success: boolean;
        productName: string;
        sku: string;
    };
    toolName: string;
};

const CreatePO = ({ resultMessage, toolName }: CreatePOProps) => {
    // console.log(resultMessage, "resultMessage");
    const result = resultMessage?.createdPOs?.flatMap((parent) =>
        parent.itemsOrServices.map((item) => ({
            ...item,
            ...parent,
        }))
    );
    const tableHeader = [
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Product name
                    </span>
                </div>
            ),
            widthClass: "w-[243px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Curr. stock level{" "}
                    </span>
                </div>
            ),
            widthClass: "w-[150px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Suggested Qty
                    </span>
                </div>
            ),
            widthClass: "w-[150px] !border-r-none",
        },

        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Supplier</span>
                </div>
            ),
            widthClass: "w-[149px] ",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Draft PO ID
                    </span>
                </div>
            ),
            widthClass: "w-[145px] ",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">Status</span>
                </div>
            ),
            widthClass: "w-[124px] ",
        },
    ];

    
    const tableBody = result?.map((item, idx) => {
        return [
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3">
                                {item?.inventory?.productImageDetails?.productImages?.[0] ? (
                                    <VendorAvatar
                                        imageSrc={
                                            item?.inventory?.productImageDetails?.productAvatar ||
                                            item?.inventory?.productImageDetails?.productImages?.[0]
                                        }
                                        size={32}
                                        name={item?.inventory?.productName}
                                        containerClassname="!rounded-md"
                                    />
                                ) : (
                                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                    </div>
                                )}
                                <p className="">{item?.inventory?.productName || ""}</p>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <div>
                            <p className=" ">
                                {`${
                                    item?.inventory?.productStockDetails?.stockLevel
                                        ? `${formatMoney()?.format(
                                              item?.inventory?.productStockDetails?.stockLevel ?? 0
                                          )} ${
                                              item?.inventory?.productStockDetails
                                                  ?.unitOfMeasurement || ""
                                          }`
                                        : "N/A"
                                }`}
                            </p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">
                            {`${
                                item?.qty
                                    ? `${formatMoney()?.format(item?.qty ?? 0)} ${
                                          item?.inventory?.productStockDetails?.unitOfMeasurement ||
                                          ""
                                      }`
                                    : "N/A"
                            }`}
                        </p>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">{item?.vendor?.name || "N/A"}</p>
                    </div>
                ),
                widthClass: " !border-b",
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">{`${item?.taId ? `PO-${item?.taId}` : "N/A"}`}</p>
                    </div>
                ),
                widthClass: " !border-b",
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="bg-[#F1F5F9] text-slate-500 px-2 py-[2px] rounded-[16px]">{`${
                            item?.status?.toLowerCase() === "draft" ? "Draft created" : "N/A"
                        }`}</p>
                    </div>
                ),
                widthClass: " !border-b",
            },
        ];
    });

    return (
        <div>
            {resultMessage?.success && resultMessage?.createdPOs?.length > 0 && (
                <div>
                    
                    <CustomTable
                        tableBody={tableBody}
                        tableHeader={tableHeader}
                        isCellBordered={true}
                        stickyHeader={true}
                        headerContainerClass="!bg-slate-50 "
                        headerItemClass="font-rocGroteskMedium "
                        tableClass="mb-4"
                        isScrollable={true}
                        scrollWithin={true}
                        renderEmptyTable={() => null}
                    />
                </div>
            )}
        </div>
    );
};

export default CreatePO;
